import { FormControl, IconButton, InputLabel } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  FilterButton,
  FilterFormBody,
  FilterFormContainer,
  FilterFormHeading,
  FilterFormHeadingWrapper,
  FilterFormLabel,
  FilterMenuItem,
  FilterSelect,
} from "./Elements";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getMentorCountries } from "./query";
const FilterForm = ({
  onClose = () => {},
  clearFilter = () => {},
  setFilter = () => {},
  filter = {
    country: "",
    study: "",
    qualification: "",
  },
  university = "",
  filterCb = () => {},
  specialization = [],
}) => {
  const [countries, setCountries] = useState([]);

  const handleShowFilter = () => {
    // apply filter logic
    filterCb(filter);
    onClose();
  };

  const updateFilter = (name, value) => {
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClearFilter = () => {
    clearFilter();
  };

  useEffect(() => {
    // fetch options
    const getCountryOption = async () => {
      const res = await getMentorCountries(university);
      setCountries(res.data);
    };
    getCountryOption();
  }, [university]);

  return (
    <FilterFormContainer>
      <FilterFormHeadingWrapper>
        <IconButton style={{ marginRight: "26px" }} onClick={handleShowFilter}>
          <ArrowBackIcon style={{ color: "white" }} />
        </IconButton>
        <FilterFormHeading>Filter Mentors</FilterFormHeading>
      </FilterFormHeadingWrapper>
      <FilterFormBody>
        <FilterFormLabel>Select a Country</FilterFormLabel>
        <FormControl sx={{ minWidth: 240, maxWidth: "43vw" }} size="small">
          <InputLabel sx={{ fontSize: "16px", fontFamily: "DM Sans" }}>
            Countries
          </InputLabel>
          <FilterSelect
            value={filter.country}
            name="country"
            label="Countries"
            onChange={(e) => updateFilter("country", e.target.value)}
            IconComponent={ExpandMoreIcon}
            MenuProps={{
              sx: {
                height: 350,
              },
            }}
          >
            <FilterMenuItem value="">
              <em>None</em>
            </FilterMenuItem>
            {countries.map((c) => (
              <FilterMenuItem key={c} value={c}>
                {c}
              </FilterMenuItem>
            ))}
          </FilterSelect>
        </FormControl>

        <FilterFormLabel style={{ marginTop: "28px" }}>
          Select Area of Study
        </FilterFormLabel>
        <FormControl sx={{ minWidth: 240, maxWidth: "43vw" }} size="small">
          <InputLabel sx={{ fontSize: "16px", fontFamily: "Outfit" }}>
            Area of Study
          </InputLabel>
          <FilterSelect
            name="study"
            label="Area of Study"
            value={filter.study}
            IconComponent={ExpandMoreIcon}
            onChange={(e) => updateFilter("study", e.target.value)}
            MenuProps={{
              sx: {
                height: 350,
              },
            }}
          >
            <FilterMenuItem value="">
              <em>None</em>
            </FilterMenuItem>
            {specialization.map((s) => (
              <FilterMenuItem key={s} value={s}>
                {s}
              </FilterMenuItem>
            ))}
          </FilterSelect>
        </FormControl>

        <FilterFormLabel style={{ marginTop: "28px" }}>
          Level Of Qualification
        </FilterFormLabel>
        <FormControl sx={{ minWidth: 240, maxWidth: "43vw" }} size="small">
          <InputLabel sx={{ fontSize: "16px", fontFamily: "Outfit" }}>
            Level
          </InputLabel>
          <FilterSelect
            name="qualification"
            label="Level"
            value={filter.qualification}
            IconComponent={ExpandMoreIcon}
            onChange={(e) => updateFilter("qualification", e.target.value)}
            MenuProps={{
              sx: {
                height: 350,
              },
            }}
          >
            <FilterMenuItem value="">
              <em>None</em>
            </FilterMenuItem>
            {/* <FilterMenuItem value="ug">Under Graduate</FilterMenuItem> */}
            <FilterMenuItem value="pg">Post Graduate</FilterMenuItem>
          </FilterSelect>
        </FormControl>

        <FilterButton style={{ left: "20px" }} onClick={handleClearFilter}>
          Clear Filters
        </FilterButton>
        <FilterButton style={{ right: "20px" }} onClick={handleShowFilter}>
          Show results
        </FilterButton>
      </FilterFormBody>
    </FilterFormContainer>
  );
};

export default FilterForm;
